const Graph = require('./BaseGraph')

module.exports = class AccountGraph extends Graph 
{
    constructor(apiDomain, path="account")
    {
        super(apiDomain, path)
    }

    accountQuery(fields, params=null)
    {
        if (params)
            return { type: 'account', query: this.queryString('account', fields, params) }

        return { type: 'account', query: `query getAccount ($accountId: String!) {
            account(accountId: $accountId)
            ${this.queryFields(fields)}
        }` }
    }

    accountByUserIdQuery(fields, params=null)
    {
        if (params)
            return { type: 'accountByUserId', query: this.queryString('accountByUserId', fields, params) }

        return {
            type: 'accountByUserId', query: `query accountByUserId ($userId: String!) {
            accountByUserId(userId: $userId)
            ${this.queryFields(fields)}
        }` }
    }

    createAccountMutation(fields, params = null)
    {
        if (params)
            return {
                type: 'createAccount', query: `mutation {
                createAccount(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return {
            type: 'createAccount', query: `mutation createAccount ($first_name: String!, $last_name: String!, $email: String!, $phone: String!, $password: String!, $type: String, $other_data: String) {
            createAccount(first_name: $first_name, last_name: $last_name, email: $email, phone: $phone, password: $password, type: $type, other_data: $other_data)
            ${this.queryFields(fields)}
        }` }
    }

    createAccountByContactMutation(fields, params = null)
    {
        if (params)
            return {
                type: 'createAccountByContact', query: `mutation {
                createAccountByContact(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return {
            type: 'createAccountByContact', query: `mutation createAccountByContact ($contact_id: String!) {
            createAccountByContact(contact_id: $contact_id)
            ${this.queryFields(fields)}
        }` }
    }

    accountDataQuery(fields, params=null)
    {
        if (params)
            return { type: 'accountData', query: this.queryString('accountData', fields, params) }
            
        return { type: 'accountData', query: `query getAccountData ($accountId: String!, $name: String!) {
            accountData(accountId: $accountId, name: $name)
            ${this.queryFields(fields)}
        }` }
    }

    accountProfileQuery(fields, params=null)
    {
        if (params)
            return { type: 'accountProfile', query: this.queryString('accountProfile', fields, params) }

        return { type: 'accountProfile', query: `query getAccountProfile ($accountId: String!){
            accountProfile(accountId: $accountId)
            ${this.queryFields(fields)}
        }` }
    }

    accountDomainQuery(fields, params=null)
    {
        if (params)
            return { type: 'domains', query: this.queryString('domains', fields, params) }

        return { type: 'domains', query: `query domains ($accountId: String!){
            domains(accountId: $accountId)
            ${this.queryFields(fields)}
        }` }
    }

    accountSslQuery(fields, params=null)
    {
        if (params)
            return { type: 'ssl', query: this.queryString('ssl', fields, params) }

        return { type: 'ssl', query: `query ssl ($accountId: String!){
            ssl(accountId: $accountId)
            ${this.queryFields(fields)}
        }` }
    }

    accountEmailQuery(fields, params=null)
    {
        if (params)
            return { type: 'emails', query: this.queryString('emails', fields, params) }

        return { type: 'emails', query: `query emails ($accountId: String!){
            emails(accountId: $accountId)
            ${this.queryFields(fields)}
        }` }
    }

    userProfileQuery(fields, params=null)
    {
        if (params)
            return { type: 'userProfile', query: this.queryString('userProfile', fields, params) }

        return { type: 'userProfile', query: `query getUserProfile ($userId: String!){
            accountProfile(userId: $userId)
            ${this.queryFields(fields)}
        }` }
    }

    profileDataQuery(fields, params=null)
    {
        if (params)
            return { type: 'profileData', query: this.queryString('profileData', fields, params) }
            
        return { type: 'profileData', query: `query getProfileData ($accountId: String!, $name: String!, $extract_key: String, $extract_value: String) {
            profileData(accountId: $accountId, name: $name, extract_key: $extract_key, extract_value: $extract_value)
            ${this.queryFields(fields)}
        }` }
    }

    addressQuery(fields, params=null)
    {
        if (params)
            return { type: 'address', query: this.queryString('address', fields, params) }

        return { type: 'address', query: `query getAddress ($userId: String!) {
            address(userId: $userId)
            ${this.queryFields(fields)}
        }` }
    }

    calendarSettingQuery(fields, params=null)
    {
        if (params)
            return { type: 'calendarSetting', query: this.queryString('calendarSetting', fields, params) }

        return { type: 'calendarSetting', query: `query getCalendarSetting ($accountId: String!) {
            calendarSetting(accountId: $accountId)
            ${this.queryFields(fields)}
        }` }
    }

    timezoneSettingQuery(fields, params=null)
    {
        if (params)
            return { type: 'timezoneSetting', query: this.queryString('timezoneSetting', fields, params) }

        return { type: 'timezoneSetting', query: `query getTimezoneSetting ($id: ID!) {
            timezoneSetting(id: $id)
            ${this.queryFields(fields)}
        }` }
    }

    //Trial User
    saveTrialUserMutation(fields, params=null)
    {
        if (params)
            return { type: 'createTrialUser', query: `mutation {
                createTrialUser(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'createTrialUser', query: `mutation createTrialUser ($username: String!, $first_name: String!, $last_name: String!, $email: String!, $phone: String!, $password: String!, $confirm_password: String!, $shaklee_status: String!, $referral: String!, $is_agreed: Int! ) {
            createTrialUser(username: $username, first_name: $first_name, last_name: $last_name, email: $email, phone: $phone, password: $password, confirm_password: $confirm_password, shaklee_status: $shaklee_status, referral: $referral, is_agreed: $is_agreed, $hashEmail: hashEmail)
            ${this.queryFields(fields)}
        }` }
    }

    trialUserQuery(fields, params=null)
    {
        if (params)
            return { type: 'yfpTrialUser', query: `{
                yfpTrialUser(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'yfpTrialUser', query: `query getYfpTrialUser ($email: String!) {
            yfpTrialUser(email: $email)
            ${this.queryFields(fields)}
        }` }
    }

    sendActivationEmailQuery(fields, params=null)
    {
        if (params)
            return { type: 'sendActivationEmail', query: `{
                sendActivationEmail(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'sendActivationEmail', query: `query getSendActivationEmail ($email: String!) {
            sendActivationEmail(email: $email)
            ${this.queryFields(fields)}
        }` }
    }

    accountSettingQuery(fields, params=null)
    {
        if (params)
            return { type: 'accountSetting', query: `{
                accountSetting(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'accountSetting', query: `query getaccountSetting ($name: String!) {
            accountSetting(name: $name)
            ${this.queryFields(fields)}
        }` }
    }

    contactUserQuery(fields, params=null)
    {
        if (params)
            return { type: 'contactUser', query: this.queryString('contactUser', fields, params) }

        return { type: 'contactUser', query: `query getContactUser ($email: String!){
            contactUser(email: $email)
            ${this.queryFields(fields)}
        }` }
    }

    accountNotificationQuery(fields, params=null)
    {
        if (params)
            return { type: 'notificationSetting', query: `{
                notificationSetting(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'notificationSetting', query: `query notificationSetting ($userId: String!) {
            notificationSetting(userId: $userId)
            ${this.queryFields(fields)}
        }` }
    }

    //Account Data
    saveAccountDataMutation(fields, params=null)
    {
        if (params)
            return { type: 'createAccountData', query: `mutation {
                createAccountData(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'createAccountData', query: `mutation createAccountData ($user_id: String!, $name: String!, $category: String!, $content_id: Int!) {
            createAccountData(user_id: $user_id, name: $name, category: $category, content_id: $content_id)
            ${this.queryFields(fields)}
        }` }
    }

    accountProfileDataQuery(fields, params=null)
    {
        if (params)
            return { type: 'accountProfileData', query: this.queryString('accountProfileData', fields, params) }
            
        return { type: 'accountProfileData', query: `query getAccountProfileData ($accountId: String!, $name: String!) {
            accountProfileData(accountId: $accountId, name: $name)
            ${this.queryFields(fields)}
        }` }
    }

    //Smart Start
    smartStartMutation(fields, params=null)
    {
        if (params)
            return { type: 'smartStart', query: `mutation {
                smartStart(${this.queryParams(params)})
                ${this.queryFields(fields)}
            }` }

        return { type: 'smartStart', query: `mutation smartStart($userId: String!, $value: String!, $date_completed: String, $other_data: String) {
            smartStart(userId: $userId, value: $value, date_completed: $date_completed, other_data: $other_data)
            ${this.queryFields(fields)}
        }` }
    }

    // Activity
    accountActivityQuery(fields, params=null)
    {
        if (params)
            return { type: 'activity', query: this.queryString('activity', fields, params) }
            
        return { type: 'activity', query: `query activity($userId: String!, $name: String!) {
            activity(userId: $userId, name: $name)
            ${this.queryFields(fields)}
        }` }
    }

    accountAllActivityQuery(fields, params=null)
    {
        if (params)
            return { type: 'allActivity', query: this.queryString('allActivity', fields, params) }
            
        return {
            type: 'allActivity', query: `query allActivity($userId: String!, $name: String!) {
            allActivity(userId: $userId, name: $name)
            ${this.queryFields(fields)}
        }` }
    }

}